import { Breadcrumbs as BreadcrumbsComponent } from '@bridebook/web/app-basic/components/breadcrumbs/breadcrumbs.component';
import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { FC, memo } from 'react';
import { IBreadcrumbItem } from '@bridebook/web/app-shared/lib/types';

interface BreadcrumbsProps {
  breadcrumbsData: Array<IBreadcrumbItem>;
}

const BreadcrumbsContainer: FC<BreadcrumbsProps> = ({ breadcrumbsData }) => {
  const isMobile = useSelector(getIsMobile);

  return (
    <BreadcrumbsComponent
      breadcrumbsData={breadcrumbsData}
      center={!isMobile}
      reloadOnLast
      showAlways
    />
  );
};

export const Breadcrumbs = memo(BreadcrumbsContainer);
